module.exports = __webpack_public_path__ + "img/message_10.564078a2.png";